import { createFileRoute } from "@tanstack/react-router";

import { ReviewScreen } from "../../features/review";

export const Route = createFileRoute("/_auth/review")({
  component: ReviewScreen,
});
